package ui.app.assign.detail.wheel

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import api.ResourceType
import apps.App
import io.Repository
import io.github.alexzhirkevich.qrose.rememberQrCodePainter
import org.ssoft.common.ui.wheel.AppWheelFactory
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope

@Composable
fun AppEditorWheelScope.AppWheelRendererStartup(
    nnvl: AppEditorWheelScope.Wrapper,
    modifier: Modifier,
    padding: Dp = 16.dp
) {
    val imageBg = remember {
        mutableStateOf<ImageBitmap?>(null)
    }
    LaunchedEffect(nnvl.themeBgStart.state) {
        imageBg.value = Repository.files.fetchImageOrNull(nnvl.themeBgStart.state)
    }

    Box(
        modifier.padding(horizontal = padding)
            .padding(padding)
            .let {
                if (nnvl.orientation.state == App.Wheel.Theme.ORIENTATION_LAND) {
                    it.fillMaxWidth()
                        .aspectRatio(16F / 9F, false)
                } else {
                    it.fillMaxHeight()
                        .aspectRatio(9F / 16F, true)
                }
            }
    ) {
        AppWheelFactory.StartupScreen(
            modifier = Modifier.fillMaxSize(),
            bgImage = imageBg.value,
            bgColor = nnvl.themeBgColor.state,
            showQr = nnvl.activateByQr.state,
            qrX = nnvl.qrPosX.state,
            qrY = nnvl.qrPosY.state,
            qrScale = nnvl.qrScale.state,
            qrPadding = nnvl.qrPadding.state,
            qr = nnvl.qrCodePainter
        )
    }
}


@Composable
fun AppWheelScope.AppWheelRendererStartup(
    config: App.Wheel,
    qr: String,
    modifier: Modifier
) {
    val imageBg = remember {
        mutableStateOf<ImageBitmap?>(null)
    }

    LaunchedEffect(config.content.theme.backgroundStartup) {
        if (config.content.theme.backgroundStartup != ResourceType.NO_IMAGE) {
            imageBg.value = Repository.files.fetchImageOrNull(config.content.theme.backgroundStartup)
        } else {
            imageBg.value = null
        }
    }

    val qrCodePainter = rememberQrCodePainter(qr)

    AppWheelFactory.StartupScreen(
        config = config,
        bgImage = imageBg.value,
        qr = qrCodePainter,
        modifier = modifier,
    )
}